/**
 * page-rivo-debug-components.js
 *
 * Pure render functions — take an API response, return HTML into a container.
 * No API calls here. Depends on page-rivo-debug.js being loaded first for setJson().
 */

window.RivoDebugComponents = (function () {

  // ── Helpers ───────────────────────────────────────
  function safe(val, fallback) { return val != null ? val : (fallback || '—'); }
  function el(id) { return document.getElementById(id); }
  function activate(id) { var e = el(id); e.className = 'rivo-component'; return e; }

  // ── 1. Customer Details ───────────────────────────
  function renderCustomerDetails(resp) {
    var c = resp.customer || resp;
    var target = activate('component-customer-details');
    target.innerHTML = [
      '<div class="rivo-points-card">',
        '<div class="rivo-points-card__number">' + safe(c.points_tally, '0') + '</div>',
        '<div class="rivo-points-card__meta">',
          '<div class="rivo-points-card__label">pistettä</div>',
          c.loyalty_status
            ? '<span class="rivo-points-card__status">' + c.loyalty_status + '</span>'
            : '',
          c.lifetime_earnings_tally != null
            ? '<div class="rivo-points-card__lifetime">Kertynyt yhteensä: ' + c.lifetime_earnings_tally + ' p</div>'
            : '',
        '</div>',
      '</div>'
    ].join('');
  }

  // ── 2. VIP Tier ───────────────────────────────────
  function renderVipTier(resp) {
    var target = activate('component-vip-tier');
    var currentTier = resp.vip_tier || resp.current_tier || {};
    var nextTier = resp.next_tier || {};
    var currentName = currentTier.name || '—';
    var nextName = nextTier.name;
    var toSpend = nextTier.to_spend_or_earn;

    var progress = 0;
    if (currentTier.threshold != null && nextTier.threshold != null && nextTier.threshold > 0) {
      progress = Math.min(100, Math.round((currentTier.threshold / nextTier.threshold) * 100));
    }

    var html = [
      '<div class="rivo-vip-card">',
        '<div class="rivo-vip-card__tier-name">Taso: ' + currentName + '</div>',
    ];

    if (nextName && toSpend != null) {
      html = html.concat([
        '<div class="rivo-vip-card__progress-wrap">',
          '<div class="rivo-vip-card__progress-bar" style="width:' + progress + '%"></div>',
        '</div>',
        '<div class="rivo-vip-card__progress-label">Keräile ' + toSpend + ' pistettä lisää päästäksesi tasolle <strong>' + nextName + '</strong></div>',
      ]);
    } else {
      html.push('<div class="rivo-vip-card__progress-label" style="color:#888">Huipputasolla — ei seuraavaa tasoa</div>');
    }

    html.push('</div>');
    target.innerHTML = html.join('');
  }

  // ── 3. Shop Rewards ───────────────────────────────
  function renderShopRewards(rewards) {
    var target = activate('component-shop-rewards');

    if (!rewards || rewards.length === 0) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No rewards returned.</p>';
      return;
    }

    var items = rewards.map(function (r) {
      return [
        '<div class="rivo-reward-item">',
          '<div class="rivo-reward-item__info">',
            '<div class="rivo-reward-item__name">' + r.name + '</div>',
            '<div class="rivo-reward-item__cost">' + r.points_amount + ' pistettä' +
              ' <span class="rivo-reward-item__type">' + r.points_type + ' / ' + r.reward_type + '</span>' +
            '</div>',
          '</div>',
          '<button class="rivo-reward-item__btn" onclick="RivoDebug.testRedeem(' + r.id + ', this)" data-reward-id="' + r.id + '">',
            'Lunasta',
          '</button>',
        '</div>'
      ].join('');
    });

    target.innerHTML = '<div class="rivo-rewards-list">' + items.join('') + '</div>';
  }

  // ── 9. Referral Stats ─────────────────────────────
  function renderReferrals(resp) {
    var target = activate('component-referrals');
    var url = resp.referral_url || resp.url || '';
    var code = resp.referral_code || resp.code || '';
    var count = resp.total_referrals || resp.count || 0;
    var pending = resp.pending_referrals || 0;
    var completed = resp.completed_referrals || resp.successful_referrals || 0;

    target.innerHTML = [
      '<div class="rivo-referral-card">',
        url
          ? [
              '<div class="rivo-referral-card__url-row">',
                '<div class="rivo-referral-card__url">' + url + '</div>',
                '<button class="rivo-referral-card__copy" onclick="navigator.clipboard.writeText(\'' + url.replace(/'/g, "\\'") + '\');this.textContent=\'Kopioitu!\';setTimeout(()=>this.textContent=\'Kopioi\',1500)">Kopioi</button>',
              '</div>',
            ].join('')
          : '<p style="color:#888;font-size:13px;">Ei viittauslinkkiä</p>',
        code ? '<div style="font-size:12px;color:#888;">Koodi: <strong>' + code + '</strong></div>' : '',
        '<div class="rivo-referral-card__stats">',
          '<div class="rivo-referral-card__stat"><div class="rivo-referral-card__stat-number">' + count + '</div><div class="rivo-referral-card__stat-label">yhteensä</div></div>',
          '<div class="rivo-referral-card__stat"><div class="rivo-referral-card__stat-number">' + pending + '</div><div class="rivo-referral-card__stat-label">odottaa</div></div>',
          '<div class="rivo-referral-card__stat"><div class="rivo-referral-card__stat-number">' + completed + '</div><div class="rivo-referral-card__stat-label">valmis</div></div>',
        '</div>',
      '</div>'
    ].join('');
  }

  // ── 10. Points Activity Log ───────────────────────
  function renderPointsLogs(resp) {
    var target = activate('component-points-logs');
    var logs = resp.points_logs || resp.logs || (Array.isArray(resp) ? resp : []);

    if (!logs.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No points activity found.</p>';
      return;
    }

    var rows = logs.slice(0, 15).map(function (log) {
      var pts = log.points_amount || log.points || 0;
      var sign = pts >= 0 ? '+' : '';
      var color = pts >= 0 ? '#1a7a42' : '#cc0000';
      var note = log.external_note || log.note || log.description || '—';
      var date = log.created_at ? new Date(log.created_at).toLocaleDateString('fi-FI') : '';
      return [
        '<div class="rivo-activity-item">',
          '<div class="rivo-activity-item__note">' + note + '</div>',
          '<div class="rivo-activity-item__right">',
            '<span class="rivo-activity-item__points" style="color:' + color + '">' + sign + pts + ' p</span>',
            date ? '<span class="rivo-activity-item__date">' + date + '</span>' : '',
          '</div>',
        '</div>'
      ].join('');
    });

    target.innerHTML = '<div class="rivo-activity-feed">' + rows.join('') + '</div>';
  }

  // ── 11. Cart Earnings Estimation ──────────────────
  function renderCartEarnings(resp) {
    var target = activate('component-cart-earnings');
    var points = resp.points || resp.estimated_points || resp.earnings || resp.total_points || 0;
    var msg = resp.message || '';

    if (typeof resp === 'number') points = resp;

    target.innerHTML = [
      '<div class="rivo-cart-earnings">',
        '<div class="rivo-cart-earnings__icon">&#9733;</div>',
        '<div class="rivo-cart-earnings__text">',
          points > 0
            ? 'Tienaat tällä tilauksella <strong>' + points + ' pistettä</strong>!'
            : 'Lisää tuotteita ostoskoriin ansaitaksesi pisteitä.',
        '</div>',
        msg ? '<div class="rivo-cart-earnings__note">' + msg + '</div>' : '',
      '</div>'
    ].join('');
  }

  // ── 12. Best Reward to Show ───────────────────────
  function renderBestReward(resp) {
    var target = activate('component-best-reward');
    var reward = resp.reward || resp;
    var name = reward.name || reward.title || '';
    var cost = reward.points_amount || reward.points_cost || reward.cost || 0;
    var pointsNeeded = reward.points_needed || reward.points_away || null;

    if (!name) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No reward suggestion available.</p>';
      return;
    }

    target.innerHTML = [
      '<div class="rivo-nudge-card">',
        '<div class="rivo-nudge-card__reward">' + name + '</div>',
        '<div class="rivo-nudge-card__cost">' + cost + ' pistettä</div>',
        pointsNeeded != null && pointsNeeded > 0
          ? '<div class="rivo-nudge-card__away">Vielä <strong>' + pointsNeeded + ' pistettä</strong> lunastukseen!</div>'
          : '<div class="rivo-nudge-card__away" style="color:#1a7a42;">Voit lunastaa tämän nyt!</div>',
      '</div>'
    ].join('');
  }

  // ── 13. Membership ────────────────────────────────
  function renderMembership(resp) {
    var target = activate('component-membership');
    var m = resp.membership || {};
    var d = resp.details || {};

    var rows = [];
    function addRow(label, val) {
      if (val != null && val !== '') rows.push('<tr><td>' + label + '</td><td>' + val + '</td></tr>');
    }

    addRow('Status', m.status || m.state || d.status);
    addRow('Tier', m.tier_name || m.tier || d.tier_name);
    addRow('Start Date', m.start_date || d.start_date);
    addRow('Renewal', m.renewal_date || d.renewal_date);
    addRow('Price', m.price || d.price);
    addRow('Benefits', m.benefits || d.benefits);

    if (!rows.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No membership data — program may not be enabled.</p>';
      return;
    }

    target.innerHTML = [
      '<table class="rivo-debug__liquid-table">',
        '<thead><tr><th>Property</th><th>Value</th></tr></thead>',
        '<tbody>' + rows.join('') + '</tbody>',
      '</table>'
    ].join('');
  }

  // ── 14. Loyalty Gifts ─────────────────────────────
  function renderLoyaltyGifts(resp) {
    var target = activate('component-loyalty-gifts');
    var gifts = resp.gifts || resp.loyalty_gifts || (Array.isArray(resp) ? resp : []);

    if (!gifts.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No loyalty gifts available.</p>';
      return;
    }

    var items = gifts.map(function (g) {
      return [
        '<div class="rivo-reward-item">',
          '<div class="rivo-reward-item__info">',
            '<div class="rivo-reward-item__name">' + (g.name || g.title || 'Gift') + '</div>',
            g.description ? '<div class="rivo-reward-item__cost">' + g.description + '</div>' : '',
          '</div>',
          g.status ? '<span class="rivo-reward-item__type">' + g.status + '</span>' : '',
        '</div>'
      ].join('');
    });

    target.innerHTML = '<div class="rivo-rewards-list">' + items.join('') + '</div>';
  }

  // ── 15. POS QR Code ───────────────────────────────
  function renderPosQr(resp) {
    var target = activate('component-pos-qr');
    var qrUrl = resp.qr_code_url || resp.qr_url || resp.url || resp.image_url || '';
    var qrData = resp.qr_code_data || resp.data || resp.qr_data || '';

    if (qrUrl) {
      target.innerHTML = [
        '<div class="rivo-qr-card">',
          '<img src="' + qrUrl + '" alt="POS QR Code" style="max-width:200px;border:1px solid #e0e0e0;border-radius:8px;">',
          '<div style="font-size:12px;color:#888;margin-top:8px;">Näytä tämä kassalla ansaitaksesi pisteitä</div>',
        '</div>'
      ].join('');
    } else if (qrData) {
      target.innerHTML = [
        '<div class="rivo-qr-card">',
          '<div style="font-family:monospace;font-size:12px;padding:12px;background:#f5f5f5;border-radius:4px;word-break:break-all;">' + qrData + '</div>',
          '<div style="font-size:12px;color:#888;margin-top:8px;">QR data (no image URL returned)</div>',
        '</div>'
      ].join('');
    } else {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No POS QR data returned — POS integration may not be configured.</p>';
    }
  }

  // ── 16. VIP Tier Roadmap ──────────────────────────
  function renderVipRoadmap(resp) {
    var target = activate('component-vip-roadmap');
    var tiers = resp.vip_tiers || resp.tiers || (Array.isArray(resp) ? resp : []);
    var currentId = resp.current_tier_id || resp.current_id || null;

    if (!tiers.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No VIP tiers configured.</p>';
      return;
    }

    var items = tiers.map(function (t) {
      var isCurrent = (currentId && t.id === currentId);
      return [
        '<div class="rivo-tier-roadmap__item' + (isCurrent ? ' current' : '') + '">',
          '<div class="rivo-tier-roadmap__name">' + (t.name || '—') + (isCurrent ? ' &#10003;' : '') + '</div>',
          t.threshold != null ? '<div class="rivo-tier-roadmap__threshold">' + t.threshold + ' p</div>' : '',
          t.perks || t.benefits
            ? '<div class="rivo-tier-roadmap__perks">' + (t.perks || t.benefits) + '</div>'
            : '',
        '</div>'
      ].join('');
    });

    target.innerHTML = '<div class="rivo-tier-roadmap">' + items.join('') + '</div>';
  }

  // ── 17. Orders with Points ────────────────────────
  function renderOrders(resp) {
    var target = activate('component-orders');
    var orders = resp.orders || (Array.isArray(resp) ? resp : []);

    if (!orders.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No orders found.</p>';
      return;
    }

    var rows = orders.slice(0, 10).map(function (o) {
      var name = o.name || o.order_number || o.id || '—';
      var total = o.total_price || o.total || '';
      var points = o.points_earned || o.points || '';
      var date = o.created_at ? new Date(o.created_at).toLocaleDateString('fi-FI') : '';
      return '<tr><td>' + name + '</td><td>' + date + '</td><td>' + total + '</td><td>' + (points ? '+' + points + ' p' : '—') + '</td></tr>';
    });

    target.innerHTML = [
      '<table class="rivo-debug__liquid-table">',
        '<thead><tr><th>Tilaus</th><th>Pvm</th><th>Summa</th><th>Pisteet</th></tr></thead>',
        '<tbody>' + rows.join('') + '</tbody>',
      '</table>'
    ].join('');
  }

  // ── 18. Shopify Customer ──────────────────────────
  function renderShopifyCustomer(resp) {
    var target = activate('component-shopify-customer');
    var c = resp.customer || resp;
    var rows = [];

    function addRow(label, val) {
      if (val != null && val !== '') {
        var display = typeof val === 'object' ? JSON.stringify(val) : val;
        rows.push('<tr><td>' + label + '</td><td>' + display + '</td></tr>');
      }
    }

    addRow('ID', c.id);
    addRow('Email', c.email);
    addRow('Name', [c.first_name, c.last_name].filter(Boolean).join(' '));
    addRow('Phone', c.phone);
    addRow('Orders Count', c.orders_count);
    addRow('Total Spent', c.total_spent);
    addRow('Tags', Array.isArray(c.tags) ? c.tags.join(', ') : c.tags);
    addRow('Created', c.created_at);
    addRow('Accepts Marketing', c.accepts_marketing);
    addRow('Verified Email', c.verified_email);

    target.innerHTML = [
      '<table class="rivo-debug__liquid-table">',
        '<thead><tr><th>Property</th><th>Value</th></tr></thead>',
        '<tbody>' + rows.join('') + '</tbody>',
      '</table>'
    ].join('');
  }

  // ── 19. Full Referrals List ───────────────────────
  function renderReferralsList(resp) {
    var target = activate('component-referrals-list');
    var referrals = resp.referrals || (Array.isArray(resp) ? resp : []);

    if (!referrals.length) {
      target.innerHTML = '<p style="color:#888;font-size:13px;">No referrals yet.</p>';
      return;
    }

    var rows = referrals.map(function (r) {
      var name = r.name || r.email || r.referred_email || '—';
      var status = r.status || '—';
      var statusColor = status === 'completed' || status === 'complete' ? '#1a7a42' : '#cc6600';
      var points = r.points_earned || r.points || '';
      var date = r.created_at ? new Date(r.created_at).toLocaleDateString('fi-FI') : '';
      return '<tr><td>' + name + '</td><td style="color:' + statusColor + '">' + status + '</td><td>' + (points ? '+' + points + ' p' : '—') + '</td><td>' + date + '</td></tr>';
    });

    target.innerHTML = [
      '<table class="rivo-debug__liquid-table">',
        '<thead><tr><th>Viittaus</th><th>Tila</th><th>Pisteet</th><th>Pvm</th></tr></thead>',
        '<tbody>' + rows.join('') + '</tbody>',
      '</table>'
    ].join('');
  }

  return {
    renderCustomerDetails: renderCustomerDetails,
    renderVipTier: renderVipTier,
    renderShopRewards: renderShopRewards,
    renderReferrals: renderReferrals,
    renderPointsLogs: renderPointsLogs,
    renderCartEarnings: renderCartEarnings,
    renderBestReward: renderBestReward,
    renderMembership: renderMembership,
    renderLoyaltyGifts: renderLoyaltyGifts,
    renderPosQr: renderPosQr,
    renderVipRoadmap: renderVipRoadmap,
    renderOrders: renderOrders,
    renderShopifyCustomer: renderShopifyCustomer,
    renderReferralsList: renderReferralsList,
  };
})();
